// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"55":"7ca5c881","117":"eac4b5ee","136":"71cea7fe","684":"8056551e","804":"d35c87c7","991":"8056551e"}[chunkId] + ".chunk.css";
};